export default __webpack_public_path__ + "e121df0fbd00874964c2e009c9f148ae.png";